import type {
	CourseMindItemSearchResult,
	CourseRegistration,
	CourseRegistrationStatus,
	SearchResponseData,
	UserCoursesPaginatedData,
} from '@kimuno/api-sdk';

import type { Pagination } from '../types/search';
import type { AsyncAction } from './common.actionTypes';

export enum CREATE_COURSE_REGISTRATION {
	START = 'CREATE_COURSE_REGISTRATION_START',
	SUCCESS = 'CREATE_COURSE_REGISTRATION_SUCCESS',
	ERROR = 'CREATE_COURSE_REGISTRATION_ERROR',
}

export type CreateCourseRegistrationAction = AsyncAction<
	typeof CREATE_COURSE_REGISTRATION.START,
	typeof CREATE_COURSE_REGISTRATION.SUCCESS,
	typeof CREATE_COURSE_REGISTRATION.ERROR,
	void,
	{ mindItemId: string }
>;

export enum GET_CERTIFIED_COURSE_REGISTRATIONS {
	START = 'GET_CERTIFIED_COURSE_REGISTRATIONS_START',
	SUCCESS = 'GET_CERTIFIED_COURSE_REGISTRATIONS_SUCCESS',
	ERROR = 'GET_CERTIFIED_COURSE_REGISTRATIONS_ERROR',
}

export type GetCertifiedCourseRegistrationsAction = AsyncAction<
	typeof GET_CERTIFIED_COURSE_REGISTRATIONS.START,
	typeof GET_CERTIFIED_COURSE_REGISTRATIONS.SUCCESS,
	typeof GET_CERTIFIED_COURSE_REGISTRATIONS.ERROR,
	CourseRegistration[],
	{ userId: string }
>;

export enum UPDATE_COURSE_REGISTRATION {
	START = 'UPDATE_COURSE_REGISTRATION_START',
	SUCCESS = 'UPDATE_COURSE_REGISTRATION_SUCCESS',
	ERROR = 'UPDATE_COURSE_REGISTRATION_ERROR',
}

export type UpdateCourseRegistrationAction = AsyncAction<
	typeof UPDATE_COURSE_REGISTRATION.START,
	typeof UPDATE_COURSE_REGISTRATION.SUCCESS,
	typeof UPDATE_COURSE_REGISTRATION.ERROR,
	CourseRegistration,
	undefined
>;

export enum FETCH_ALL_USER_COURSES {
	START = 'FETCH_ALL_USER_COURSES_START',
	SUCCESS = 'FETCH_ALL_USER_COURSES_SUCCESS',
	ERROR = 'FETCH_ALL_USER_COURSES_ERROR',
}

export type FetchAllUserCoursesAction = AsyncAction<
	typeof FETCH_ALL_USER_COURSES.START,
	typeof FETCH_ALL_USER_COURSES.SUCCESS,
	typeof FETCH_ALL_USER_COURSES.ERROR,
	UserCoursesPaginatedData,
	{ pagination: Pagination; registrationStatus?: CourseRegistrationStatus }
>;

export enum FETCH_PROGRESS_USER_COURSES {
	START = 'FETCH_PROGRESS_USER_COURSES_START',
	SUCCESS = 'FETCH_PROGRESS_USER_COURSES_SUCCESS',
	ERROR = 'FETCH_PROGRESS_USER_COURSES_ERROR',
}

export type FetchProgressUserCoursesAction = AsyncAction<
	typeof FETCH_PROGRESS_USER_COURSES.START,
	typeof FETCH_PROGRESS_USER_COURSES.SUCCESS,
	typeof FETCH_PROGRESS_USER_COURSES.ERROR,
	UserCoursesPaginatedData,
	{ pagination: Pagination; registrationStatus?: CourseRegistrationStatus }
>;

export enum FETCH_SUCCESS_USER_COURSES {
	START = 'FETCH_SUCCESS_USER_COURSES_START',
	SUCCESS = 'FETCH_SUCCESS_USER_COURSES_SUCCESS',
	ERROR = 'FETCH_SUCCESS_USER_COURSES_ERROR',
}

export type FetchSuccessUserCoursesAction = AsyncAction<
	typeof FETCH_SUCCESS_USER_COURSES.START,
	typeof FETCH_SUCCESS_USER_COURSES.SUCCESS,
	typeof FETCH_SUCCESS_USER_COURSES.ERROR,
	UserCoursesPaginatedData,
	{ pagination: Pagination; registrationStatus?: CourseRegistrationStatus }
>;

export enum FETCH_NEW_COURSES {
	START = 'FETCH_NEW_COURSES_START',
	SUCCESS = 'FETCH_NEW_COURSES_SUCCESS',
	ERROR = 'FETCH_NEW_COURSES_ERROR',
}

export type FetchNewCoursesAction = AsyncAction<
	typeof FETCH_NEW_COURSES.START,
	typeof FETCH_NEW_COURSES.SUCCESS,
	typeof FETCH_NEW_COURSES.ERROR,
	SearchResponseData<CourseMindItemSearchResult>
>;
